import styled from "styled-components";
import { H3 } from "../../../../common";

export const PageLinkText = styled(H3)`
  color: ${({ theme }) => theme.colors.textColor};
`;
